import { render } from "./delete.vue?vue&type=template&id=d0580f1c&ts=true"
import script from "./delete.vue?vue&type=script&lang=ts"
export * from "./delete.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\AttiTec\\DogToDo\\dev\\todo-list-vuejs-pwa-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__